import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendar = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 9,
			y: 9.88,
			width: 22,
			height: 21.12,
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 26.5,
			y1: 8,
			x2: 26.5,
			y2: 11.76,
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 13.6667,
			y1: 8,
			x2: 13.6667,
			y2: 11.76,
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 9,
			y1: 16.56,
			x2: 31,
			y2: 16.56,
			stroke: "currentColor",
			strokeWidth: 2
		})
	]
});
const ForwardRef = forwardRef(SvgCalendar);
export default ForwardRef;
